import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import lodashCompact from 'lodash/fp/compact';

import { SCREEN_ID_RESET_PASSWORD_CONFIRM } from 'client/constants/screenIds';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import branch from 'client/core/branch';
import UtilityAuthActions from 'client/actions/UtilityAuth';
import UtilityPartnerActions from 'client/actions/UtilityPartner';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import Navbar from 'client/components/Navbar';
import SrLink from 'client/components/SrLink/SrLink';
import SrPasswordResetForm from 'client/components/SrPasswordResetForm';

@withTransitionHook
@branch(({ match }) => {
  const cursors = {
    isMobileApp: ['mobileApp', 'isMobileApp'],
  };

  if (match.params.partnerSlug) {
    cursors.utilityPartner = ['utilityPartners', 'bySlug', match.params.partnerSlug];
  }

  return cursors;
})
@withScreenId(SCREEN_ID_RESET_PASSWORD_CONFIRM)
@withScrollToTop
class UtilityResetPasswordConfirmPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Utility Profit',
    section: SCREEN_ID_RESET_PASSWORD_CONFIRM,
    keywords: 'utility profit, reset password',
    description: 'Reset your utility profit password.',
  });

  static fetchData(match, inject) {
    return Promise.all(
      lodashCompact([
        match.params.partnerSlug &&
          UtilityPartnerActions.getBySlug(inject, {
            slug: match.params.partnerSlug,
          }),
      ]),
    );
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
  };

  onPasswordResetFormSubmit = (formValues) => {
    const { dispatch, history, location } = this.props;

    const { token } = queryString.parse(location.search);
    dispatch(UtilityAuthActions.resetPasswordRequested, {
      token: token,
      password: formValues.password,
    }).then(() => {
      history.push('/utility-setup/session');
    });
  };

  render() {
    const { location, utilityPartner } = this.props;

    const urlParts = location.pathname.split('/');
    urlParts.pop();

    const isUtilityProfit = urlParts[1] === 'utility-profit';

    return (
      <div className="page-reset-password">
        <Navbar
          disableRedirect
          customLogo={
            <SrFlex justify="center">
              <SrBox
                backgroundSize="contain"
                backgroundPosition="center"
                backgroundRepeat="no-repeat"
                height="40px"
                width="100%"
                maxWidth="166px"
                backgroundImage={`url(${
                  isUtilityProfit ? '/images/utility-profit-logo.svg' : utilityPartner?.logoUrl
                })`}
              />
            </SrFlex>
          }
          leftButton={
            <SrLink
              className="link back"
              redirectToLastLocation
              restoreScrollPosition
              to={urlParts.join('/')}
            >
              Back
            </SrLink>
          }
        />
        <div className="resetContainer">
          <div className="resetFormContainer">
            <SrPasswordResetForm
              onSubmit={this.onPasswordResetFormSubmit}
              locationQuery={queryString.parse(location.search)}
            />
          </div>
        </div>
      </div>
    );
  }
}

UtilityResetPasswordConfirmPage.displayName = 'UtilityResetPasswordConfirmPage';

export default UtilityResetPasswordConfirmPage;
